import ApiClient from '@/services/apiClient';

export default class Parity {
    enable;
    start;
    end;
    parity_type;

    constructor(enable = false, start = 0, end = 0, parity_type = "Even") {
      this.enable = enable;
      this.start = start;
      this.end = end;
      this.parity_type = parity_type;
    }
      
    /**
     * Constructs a <code>Parity</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Parity} obj Optional instance to populate.
     * @return {module:model/Parity} The populated <code>Parity</code> instance.
     */
    static constructFromObject(data, obj) {
      obj = obj || new Parity();
      if (data) {
        obj.enable = true;
        if (Object.prototype.hasOwnProperty.call(data, 'enable'))
          obj.enable = ApiClient.convertToType(data['enable'], 'Boolean');
        if (Object.prototype.hasOwnProperty.call(data, 'start'))
          obj.start = ApiClient.convertToType(data['start'], 'Integer');
        if (Object.prototype.hasOwnProperty.call(data, 'end'))
          obj.end = ApiClient.convertToType(data['end'], 'Integer');
        if (Object.prototype.hasOwnProperty.call(data, 'parity_type'))
          obj.parity_type = ApiClient.convertToType(data['parity_type'], 'String');
      }
      return obj;
    }

    static fromConfig(config) {
      if(config.parities) {
        return ApiClient.convertToType(config.parities, [Parity]);
      } else {
        return [new Parity(), new Parity()];
      }
    }
}